export default {
      id: "planner-minus-usage",
      viewBox: "0 0 8 2",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-minus",
      toString: function () {
        return this.url;
      }
    }